module.exports = __webpack_public_path__ + "img/1485751552.109c81d6.jpg";